export default __webpack_public_path__ + "static/Futura-Medium-0099b453a0225c7fadcb5c0db6608bb5.woff";